import React from "react";
import styled, { css } from "styled-components";

interface Props {
  label: React.ReactNode;
  value: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}

const Wrapper = styled.div<{ $noPadding?: boolean }>`
  color: var(--gray400);
  font-size: 15px;
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;

  ${(props) =>
    props.$noPadding &&
    css`
      margin-bottom: 0;
    `}
`;

const ValueText = styled.span`
  flex: 1 1 auto;
  word-wrap: break-word;
  overflow: hidden;
`;

const LabelText = styled.span`
  padding-right: 10px;
  color: var(--gray100);
  white-space: nowrap;
`;

const KeyValue = (props: Props) => {
  const { label, value, className, noPadding } = props;

  return (
    <Wrapper className={className} $noPadding={noPadding}>
      <LabelText>{label}:</LabelText>
      <ValueText>{value}</ValueText>
    </Wrapper>
  );
};

export default KeyValue;
